import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../event-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useEventTags from '../../hooks/useEventTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function StudentAges(props) {
  const { event } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const eventAges = useEventTags(event, TagTypes.Age, timestamp);

  let subtitle = '';

  if (eventAges.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = eventAges.data.map(function(eventAge) {
      return eventAge.data.name;
    }).join(', ');
  }

  return (
    <DataCard
      title="Student Ages"
      icon={UsersIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(event).STUDENT_AGE)}
    />
  );
};
